import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CurrencyService } from '../proxy/controlling/controllers/currency.service';

FieldBuilder.setNamespace('Controlling');

export const EXCHANGETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('value', 'Entity.ExchangeType.Value')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .date('documentDate', 'Entity.ExchangeType.DocumentDate')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'currencyId',
    'Entity.Currency',
    CurrencyService
  )
    .required()
    .displayFromNested('currency.name')
    .sortBy('currency.name')
    .build(),
];

export const EXCHANGETYPE_CONFIG = {
  entityName: 'ExchangeType',
  localizationKey: 'Controlling::Entity.ExchangeType',
  fields: EXCHANGETYPE_FIELDS,
  permission: 'ControllingLiquidations.ExchangeTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
